import {
    IMenuByTypesItem,
    IMenuItem,
    ResponseDto as MenuResponseDto,
} from '@r1-frontend/api-domru/api-content/v2/menu/by-types';

import { INewMenuItems } from '~/src/store/reducers/menu';

/**
 * Проверка доступности пункта или подпункта меню
 * available: 0 (не показывать) | 1 (показывать)
 * view: 0 (всем) | 1 (только авторизованным) | 2 (только неавторизованным)
 */
export enum ViewAccess {
    ALL = 0,
    AUTH = 1,
    UNAUTH = 2,
}

type TMenuItem = IMenuByTypesItem | IMenuItem;

export const shouldShowBasedOnAuth = (view: number, isAuth: boolean) =>
    view === ViewAccess.ALL || (isAuth && view === ViewAccess.AUTH) || (!isAuth && view === ViewAccess.UNAUTH);

export const isItemVisibleForUnauth = (item: TMenuItem): boolean =>
    shouldShowBasedOnAuth(item.view, false);

export const isItemVisibleForAuth = (item: TMenuItem): boolean =>
    shouldShowBasedOnAuth(item.view, true);

export const getFilteredMenuItems = (menuItems: Array<IMenuByTypesItem>, filterHandler: (item: TMenuItem) => boolean) => {
    return menuItems
        .filter(filterHandler)
        .map((item) => {
            if (!item.children) {
                return item;
            }
            // фильтруем вложенные элементы, вложенность Array<{ children: Array<{ children }> }>
            const filteredChildren = item.children?.map((child) => {
                if (!child.children) {
                    return child;
                }

                const filteredGrandchildren = child.children.filter(filterHandler);
                return { ...child, children: filteredGrandchildren };
            });

            return { ...item, children: filteredChildren };
        });
};

export const findIntercom = (item: TMenuItem) => item.link === '/domofon'; // селектор

export const formatterMenuDataByResponse = (menu: MenuResponseDto): INewMenuItems => {
    const { main, partners, WebUnderMenu, service } = menu;
    return ({
        partners,
        WebUnderMenu,
        service,

        authMain: getFilteredMenuItems(main, isItemVisibleForAuth),
        unauthMain: getFilteredMenuItems(main, isItemVisibleForUnauth),
    });
};
